import { render, staticRenderFns } from "./SinglePdfPreview.vue?vue&type=template&id=7996731a&scoped=true"
import script from "./SinglePdfPreview.vue?vue&type=script&lang=ts"
export * from "./SinglePdfPreview.vue?vue&type=script&lang=ts"
import style0 from "./SinglePdfPreview.vue?vue&type=style&index=0&id=7996731a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7996731a",
  null
  
)

export default component.exports